import { useFetch } from "@/hooks/useFetch";
import { fetchDiscordForProject } from "components/project/integration/api";

export const useDiscordData = (id) => {
    const { data: discordData } = useFetch({
        queryKey: ["project-discord-integrations", id],
        queryFn: () => fetchDiscordForProject({ id: id }),
    });

    const discordChannelIds = Array.isArray(discordData)
        ? discordData
            .map((entry) => ({
                project_service_id: entry?.id,
                channelId: entry?.item?.channel_id,
                chat_id: entry?.item?.id,
            }))
            .filter((channel) => Boolean(channel.channelId))
        : [];

    return {
        discordData,
        discordChannelIds,
    };
};
